import "./index.css";
export const ClosedAdminTabs = ({ name, key, onClick }) => {
  return (
    <div className="closed-admin-tabs" key={key} onClick={onClick}>
      <p>{name}</p>
    </div>
  );
};
